import { ServiceEngine } from '@mirai/services';

export const fetchConfig = ({ id, type = 'hotel' } = {}) => (id ? ServiceEngine.get({ id, type }) : undefined);
